import {useContext} from "react";
import ImageViewContext from "context/ImageViewContext";

type ImagesType = string | string[];

export interface UseImageViewerReturn {
  openImageViewer: (images: ImagesType, index?: number) => void,
  closeImageViewer: () => void,
}

/**
 * The hook create store for the modal
 * @return {UseImageViewerReturn}
 * @constructor
 */
export default function useImageViewer(): UseImageViewerReturn {
  const {setImageViewerData} = useContext(ImageViewContext);

  function openImageViewer(images: ImagesType, index?: number) {
    const imageViewerData = {
      images: images,
      isOpened: true,
      index: 0,
    }

    if (index) {
      imageViewerData.index = index
    }

    console.log('imageViewerData is', imageViewerData)

    setImageViewerData(imageViewerData)
  }

  function closeImageViewer() {
    setImageViewerData({
      images: [],
      isOpened: false,
      index: 0,
    })
  }

  return {
    openImageViewer,
    closeImageViewer,
  };
}
